import request from '@/utils/request'
const BASE_URL = '/Process'

//流程
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  //获取流程树形数据
  getTreeProcess(id) {
    return request({
      url: BASE_URL + '/GetTreeProcess',
      method: 'post',
      params: { id }
    })
  },
  //获取流程树形数据
  getTreeVersion(versionId) {
    return request({
      url: BASE_URL + '/GetTreeVersion',
      method: 'post',
      params: { versionId }
    })
  },
  //保存流程树形数据
  saveTreeProcess(data) {
    return request({
      url: BASE_URL + '/SaveTreeProcess',
      method: 'post',
      data
    })
  },
  //获取序号
  getMaxSort() {
    return request({
      url: BASE_URL + '/GetMaxSort',
      method: 'get',
    })
  },
}